import { render, staticRenderFns } from "./zfjs_add.vue?vue&type=template&id=0b5c2752&"
import script from "./zfjs_add.vue?vue&type=script&lang=js&"
export * from "./zfjs_add.vue?vue&type=script&lang=js&"
import style0 from "./zfjs_add.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports